import React from 'react';
import { getParticipantImage } from '../services/TournamentAssets';
import './TournamentResultPopup.css';

function FighterBadge({ participant, score, mood, label }) {
  return (
    <div className={`tournament-result-fighter ${mood === 'depressed' ? 'is-sad' : ''}`}>
      <img
        src={getParticipantImage(participant, mood)}
        alt={participant?.name || 'Fighter'}
      />
      <span className="tournament-result-fighter-label">{label}</span>
      <strong>{participant?.name || 'Unknown'}</strong>
      <span className="tournament-result-score">{score} pt</span>
    </div>
  );
}

function TournamentResultPopup({ notice, onClose }) {
  if (!notice) return null;

  if (notice.type === 'champion') {
    const champion = notice.champion;

    return (
      <div className="tournament-result-overlay" role="presentation" onClick={onClose}>
        <div
          className="tournament-result-popup tournament-result-champion"
          role="dialog"
          aria-modal="true"
          aria-labelledby="tournament-result-title"
          onClick={(event) => event.stopPropagation()}
        >
          <button
            type="button"
            className="tournament-result-close"
            onClick={onClose}
            aria-label="Close tournament champion result"
          >
            x
          </button>

          <div className="tournament-result-heading">
            <span>{notice.month || 'Tournament'}</span>
            <h2 id="tournament-result-title">{notice.title || 'Champion Crowned!'}</h2>
            <p>{notice.message}</p>
          </div>

          <div className="tournament-champion-stage">
            <img
              src={getParticipantImage(champion, 'victory')}
              alt={champion?.name || 'Champion'}
            />
            <div className="tournament-champion-name">
              <span>Champion</span>
              <strong>{champion?.name || 'Unknown'}</strong>
            </div>
            <p>{notice.casterComment}</p>
          </div>

          <button type="button" className="tournament-result-primary" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    );
  }

  const userMood = notice.didWin ? 'victory' : 'depressed';
  const opponentMood = notice.didWin ? 'depressed' : 'victory';
  const title = notice.didWin ? 'Match Won!' : 'Match Lost';
  const message = notice.tieBroken
    ? 'The points were tied, so the judges made the call.'
    : `${notice.phaseLabel || 'Match'} result is ready.`;

  return (
    <div className="tournament-result-overlay" role="presentation" onClick={onClose}>
      <div
        className={`tournament-result-popup ${notice.didWin ? 'is-win' : 'is-loss'}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="tournament-result-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="tournament-result-close"
          onClick={onClose}
          aria-label="Close tournament result"
        >
          x
        </button>

        <div className="tournament-result-heading">
          <span>{notice.phaseLabel}</span>
          <h2 id="tournament-result-title">{title}</h2>
          <p>{message}</p>
        </div>

        <div className="tournament-result-fighters">
          <FighterBadge
            participant={notice.user}
            score={notice.userScore}
            mood={userMood}
            label="You"
          />
          <div className="tournament-result-vs">VS</div>
          <FighterBadge
            participant={notice.opponent}
            score={notice.opponentScore}
            mood={opponentMood}
            label="Opponent"
          />
        </div>

        <button type="button" className="tournament-result-primary" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
}

export default TournamentResultPopup;
